import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { CreateChartService } from "../../services/create-chart.service";
import { StateService } from "../../services/state.service";
import html2canvas from "html2canvas";

@Component({
  selector: "app-chart-highcharts",
  templateUrl: "./chart-highcharts.component.html",
  styleUrl: "./chart-highcharts.component.scss",
})
export class ChartHighchartsComponent implements OnChanges, AfterViewInit {
  @Input() chartIds: any[] = [];
  @Input() chartData: any;
  @Input() containerId: string = "";
  @Input() showLoader: boolean = true;
  containerIds: any[] = ["overall", "country", "region", "state", "channel"];
  macoTableView: boolean = false;
  revenueTableView: boolean = false;
  volumeTableView: boolean = false;
  excelHeader: any = [
    {
      label: "Category",
      value: "name",
    },
    {
      label: "Value",
      value: "y",
    },
  ];

  constructor(
    private chartService: CreateChartService,
    private stateService: StateService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.chartData) {
      this.chartIds = this.chartIds.map((id) => this.containerId.concat(id));
      this.chartData = changes.chartData.currentValue;
      setTimeout(() => {
        this.createAndAppendDiv();
      }, 200);
      setTimeout(() => {
        this.getWaterfallChartData(this.chartIds);
      }, 10);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getWaterfallChartData(this.chartIds);
    }, 0);
  }

  createAndAppendDiv() {
    const targetElement = document.getElementById(this.containerId);
    if (targetElement) {
      targetElement.innerHTML = "";
    }
    for (const id of this.chartIds) {
      const newDiv = document.createElement("div");
      newDiv.setAttribute("id", id);

      if (targetElement) {
        targetElement.appendChild(newDiv);
      }
    }
  }

  nParseFloat(val: any) {
    if (typeof val === "string") {
      return val !== "" ? val : "-";
    } else if (this.isInt(val)) {
      return this.formatNumber(val);
    } else if (val && typeof val !== "string" && !this.isInt(val)) {
      const floatVal = parseFloat(val.toFixed(1));
      return this.formatNumber(floatVal);
    } else {
      return val || "-";
    }
  }

  isInt(num: any) {
    return Number(num) === num && num % 1 === 0;
  }

  formatNumber(num: number): string {
    const numValue = typeof num === "string" ? parseFloat(num) : num;
    if (typeof numValue !== "number" || !isFinite(numValue)) return "";
    const [integerPart, decimalPart] = Math.abs(numValue).toString().split(".");
    const safeInteger = integerPart.replace(/\d(?=(\d{3})+$)/g, "$&,");
    return (
      (numValue < 0 ? "-" : "") +
      safeInteger +
      (decimalPart ? "." + decimalPart : "")
    );
  }

  showTableView(event: any) {
    let triggerChartView: boolean = false;
    switch (event) {
      case "maco":
        this.macoTableView = !this.macoTableView;
        triggerChartView = this.macoTableView;
        break;
      case "revenue":
        this.revenueTableView = !this.revenueTableView;
        triggerChartView = this.revenueTableView;
        break;
      case "volume":
        this.volumeTableView = !this.volumeTableView;
        triggerChartView = this.volumeTableView;
        break;

      default:
        break;
    }
    // If we just switched to chart view (table view turned off), trigger a window resize
    // so chart libraries can reflow. Delay briefly to let DOM updates complete.
    if (triggerChartView === false) {
      setTimeout(() => window.dispatchEvent(new Event("resize")), 200);
    }
  }

  chartDownload(ids: string[]) {
    ids.forEach((id) => {
      const element = document.getElementById(id);
      if (!element) {
        return;
      }

      html2canvas(element)
        .then(function (canvas: any) {
          // Convert the canvas to blob
          canvas.toBlob(function (blob: any) {
            // To download directly on browser default 'downloads' location
            const link = document.createElement("a");
            link.download = id + ".png"; // Use ID for download
            link.href = URL.createObjectURL(blob);
            link.click();
            // To save manually somewhere in file explorer
          }, "image/png");
        })
        .catch((error) => {});
    });
  }

  excelDownload(excelHeader: any, excelData: any, fileName: string) {
    this.stateService.exportToExcel(excelHeader, excelData, fileName);
  }

  // getWaterfallChartData(containerNames: string[]) {
  //   containerNames.forEach((containerName) => {
  //     this.chartService.setWaterfallChartData(
  //       containerName,
  //       this.chartData?.macoData,
  //       this.chartData?.volumeData,
  //       this.chartData?.revenueData
  //     );
  //   });
  // }
  // ...existing code...
  getWaterfallChartData(containerNames: string[]) {
    const maco = this.chartData?.macoData;
    const volume = this.chartData?.volumeData;
    const revenue = this.chartData?.revenueData;
    const hasData = (arr: any) => Array.isArray(arr) && arr.length > 0;
    // If there's no series data at all, don't attempt to render charts.
    if (!hasData(maco) && !hasData(volume) && !hasData(revenue)) {
      // clear any created chart containers and show a single no-data placeholder

      containerNames.forEach((containerName: any) => {
        const target = document.getElementById(containerName);
        if (target) {
          target.innerHTML = `<div class="no-data flex items-center justify-center py-9 px-3 text-gray-500">No data found</div>`;
        }
      });
      return;
    }

    containerNames.forEach((containerName: any) => {
      this.chartService.setWaterfallChartData(
        containerName,
        maco,
        volume,
        revenue,
      );
    });
  }
}
